module.exports = __webpack_public_path__ + "static/media/Cats eyes 07_TYSKA-mixdown.6a14e625.mp3";